import { IApplicationState } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';

export const getAsidePanelIsGoogleFileCreating = (
    state: IApplicationState
): boolean => {
    return getAsidePanel(state).isGoogleFileCreating;
};
